module.exports = __webpack_public_path__ + "static/SectionOne-e2bf0142595873186a2df25aacb650c5.png";